import { TFunction } from 'i18next';
import _find from 'lodash/find';
import {
  DocumentationRenewalRepetitionEnum,
  EdmDocumentRenewalReminderTemplateFragmentFragment,
} from 'graphql-common';
import DocumentFormFieldNames from '@lib/enums/fieldNames/documentFormFieldNames';
import { Values } from '@lib/interfaces/form';
import { dateOnlyToDatePickerValue } from '@lib/utils/dateTimeHelpers';
import getNextDateFromMonthDay from '../../utils/getNextDateFromMonthDay';
import getRenewalRepetitionOptions from './getRenewalRepetitionOptions';

export default function getRenewalReminderTemplateValues(
  t: TFunction<'translation', undefined>,
  template?: EdmDocumentRenewalReminderTemplateFragmentFragment | null,
): Values | null {
  if (!template) return null;

  const {
    renewalRepetition,
    renewalRepetitionCustomDays,
    renewalDeadlineMd,
    renewalEarlyReminderDays,
  } = template;

  const hasAnyValue =
    !!renewalRepetition ||
    renewalRepetitionCustomDays != null ||
    !!renewalDeadlineMd ||
    renewalEarlyReminderDays != null;
  if (!hasAnyValue) return null;

  const options = getRenewalRepetitionOptions(t);
  const repetitionOption = renewalRepetition
    ? _find(options, ({ value }) => value === renewalRepetition) || options[0]
    : options[0];

  const isCustom =
    repetitionOption?.value === DocumentationRenewalRepetitionEnum.Custom;

  return {
    [DocumentFormFieldNames.RenewalReminderEnabled]: true,
    [DocumentFormFieldNames.RenewalReminderRepetition]: repetitionOption,
    [DocumentFormFieldNames.RenewalReminderCustomDays]:
      isCustom && renewalRepetitionCustomDays != null
        ? renewalRepetitionCustomDays
        : null,
    [DocumentFormFieldNames.RenewalReminderEarlyAmount]:
      renewalEarlyReminderDays ?? 1,
    [DocumentFormFieldNames.RenewalReminderDeadlineDate]:
      dateOnlyToDatePickerValue(getNextDateFromMonthDay(renewalDeadlineMd)),
  };
}
